import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalLoaderComponent } from './modal-loader/modal-loader.component';
import { ModalMessageComponent } from './modal-message/modal-message.component';
import { ModalComponent } from './modal/modal.component';
import { NewModalMessageComponent } from './new-modal-message/new-modal-message.component';
import { ModalAlteracoesComponent } from './modal-alteracoes/modal-alteracoes.component';
import { ModalContainerGenericComponent } from './modal-container-generic/modal-container-generic.component';
import { PlusModalComponent } from './plus-modal/plus-modal.component';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    ],
  declarations: [
    ModalComponent,
    ModalLoaderComponent,
    ModalMessageComponent,
    NewModalMessageComponent,
    ConfirmModalComponent,
    ModalAlteracoesComponent,
    ModalContainerGenericComponent,
    PlusModalComponent
  ],
  exports: [
    ModalComponent,
    ModalLoaderComponent,
    ModalMessageComponent,
    NewModalMessageComponent,
    ConfirmModalComponent,
    ModalContainerGenericComponent,
    PlusModalComponent
  ],
  entryComponents: [
    ConfirmModalComponent
  ]
})
export class ModaisModule { }
